import { useEffect } from 'react';
import PrivacyPolicyDocument from '@/components/legal/PrivacyPolicyDocument';

export default function TermsServicePage() {
  useEffect(() => {
    // scroll to top smoothly when page loads
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  return (
    <div className="pt-16 sm:pt-20 pb-10">
      <PrivacyPolicyDocument />
    </div>
  );
}
